import { Link } from 'react-router-dom';
import { getCustomerFacingPayments, getFooterPaymentIconIds } from '../lib/stripePaymentMethodsData';
import { PaymentBrandIconRow } from './PaymentBrandIcons';

/** Alleen beschikbare (ingeschakelde) methoden — klantvriendelijk met iconen. */
export function PaymentMethodsOverview() {
  const rows = getCustomerFacingPayments();

  return (
    <div className="space-y-8">
      <p className="text-sm leading-relaxed text-ct-muted">
        Hieronder staan de betaalmethoden die wij <strong className="text-ct-text">actief hebben ingeschakeld</strong> in
        onze betaalomgeving (Stripe). Op de betaalpagina zelf bepaalt Stripe — op basis van jouw land, bank en apparaat —
        welke van deze opties je precies te zien krijgt.
      </p>

      <div className="grid gap-4 sm:grid-cols-2">
        {rows.map((row) => (
          <article
            key={row.key}
            className="flex flex-col rounded-2xl border border-ct-border bg-ct-surface/90 p-5 shadow-sm transition hover:border-ct-accent/25"
          >
            <PaymentBrandIconRow ids={row.icons} className="mb-4" />
            <h2 className="text-base font-bold text-ct-text">{row.customerLabel}</h2>
            <p className="mt-2 text-sm leading-relaxed text-ct-muted">{row.customerHint}</p>
          </article>
        ))}
      </div>

      <p className="rounded-xl border border-dashed border-ct-border bg-ct-elevated/30 px-4 py-3 text-xs leading-relaxed text-ct-muted">
        Betaling verloopt via een beveiligde pagina van Stripe. Voor vragen over je bankpas, limiet of een geweigerde
        betaling: neem contact op met je bank of met ons via{' '}
        <Link to="/contact" className="font-semibold text-ct-accent hover:underline">
          contact
        </Link>
        .
      </p>
    </div>
  );
}

/** Opvallend blok op de prijzenpagina: iconen + korte uitleg. */
export function PaymentMethodsPromoSection() {
  const rows = getCustomerFacingPayments();

  return (
    <section
      className="relative overflow-hidden rounded-3xl border-2 border-ct-accent/25 bg-gradient-to-br from-ct-accent/[0.09] via-ct-surface to-ct-elevated/40 px-6 py-8 sm:px-10 sm:py-10"
      aria-labelledby="payment-methods-promo-title"
    >
      <div
        className="pointer-events-none absolute -right-16 top-0 h-48 w-48 rounded-full bg-ct-accent/10 blur-3xl"
        aria-hidden
      />
      <div className="relative">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-ct-accent">Betaling</p>
        <h2 id="payment-methods-promo-title" className="mt-2 text-2xl font-bold tracking-tight text-ct-text sm:text-3xl">
          Veilig betalen — dit kun je gebruiken
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-ct-muted sm:text-base">
          Wij werken met Stripe. Onderstaande methoden staan bij ons aan; tijdens het afrekenen zie je welke daarvan voor
          jou beschikbaar zijn (afhankelijk van land, valuta en toestel).
        </p>

        <div className="mt-6 rounded-2xl border border-ct-border bg-white/90 px-4 py-4 dark:bg-ct-elevated/80">
          <p className="text-[11px] font-bold uppercase tracking-wide text-ct-muted">Geaccepteerde opties</p>
          <PaymentBrandIconRow ids={getFooterPaymentIconIds()} className="mt-3 gap-2.5" />
        </div>

        <ul className="mt-6 space-y-2 text-sm text-ct-text">
          {rows.map((row) => (
            <li key={row.key} className="flex gap-2">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-ct-accent" aria-hidden />
              <span>
                <strong>{row.customerLabel}</strong>
                <span className="text-ct-muted"> — {row.customerHint}</span>
              </span>
            </li>
          ))}
        </ul>

        <Link
          to="/betaalmethoden"
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-ct-text px-5 py-3 text-sm font-bold text-ct-bg transition hover:opacity-90 dark:bg-white dark:text-slate-900"
        >
          Meer uitleg bij elke methode
          <span aria-hidden>→</span>
        </Link>
      </div>
    </section>
  );
}
